import { IApiEpBillingProductFeatureSubscription } from "@smp/api";

import { useEpBillingFeature } from "@/hooks/use_ep_billing_feature";
import { useHumanizer } from "@/hooks/use_humanizer";

export const NameFeatureSubscription = ({
  productFeatureSubscription,
}: {
  productFeatureSubscription: IApiEpBillingProductFeatureSubscription;
}) => {
  const { feature } = useEpBillingFeature({
    req: {
      path: { id: productFeatureSubscription.feature },
    },
  });
  const { humanizeFeatureName } = useHumanizer();

  if (!feature) {
    return null;
  }

  return <>{humanizeFeatureName(feature.name)}</>;
};
